import { put, takeEvery, select } from 'redux-saga/effects'

import { Game, Api, Auth, Firebase } from '../../Core'

import * as mapSelectors from './map.selectors'
import * as mapActions from './map.actions'

import * as phaseActions from '../Phases/phases.actions'
import * as indicatorsActions from '../Indicators/indicators.actions'
import * as pointsManagerActions from '../PointsManager/pointsManager.actions'
import * as audioActions from '../../Core/Game/AudioContainer/audio.actions'
import * as activityActions from '../Activity/activity.actions'
import * as surveyActions from '../Survey/survey.actions'

import MapButton from './MapButton'
import MapScreen from './MapScreen'
import TilePopupContainer from './MapScreen/TilePopup/TilePopupContainer'
import * as IndicatorsSelectors from '../Indicators/indicators.selectors'

/**
 *  Components module initialization.
 */
function* init() {
  yield loadComponents()
}

/**
 * Load components.
 */
export function* loadComponents() {
  const components = {
    MapScreen,
    MapButton,
    TilePopupContainer,
  }

  yield put(Game.actions.registerComponents(components))
}

function* createBuilding(action) {
  let buildingData = action.data.building
  let tile = action.data.tile //q r

  const userInfo = yield select(Auth.selectors.getUserInfo)
  const payload = {
    groupId: userInfo.licenseData.groupId,
    playerId: userInfo.licenseId,
    building: {
      name: buildingData.id ? buildingData.id : buildingData.name,
      type: buildingData.type,
      level: buildingData.isFree && buildingData.level ? buildingData.level : 1,
      built: buildingData.isFree ? true : false,
      q: tile.q,
      r: tile.r,
      price: buildingData.isFree ? 0 : buildingData.pricePerLevel[0],
      isFree: buildingData.isFree ? buildingData.isFree : false,
    },
    extraBuildingId: buildingData.extraBuildingId ? buildingData.extraBuildingId : null,
  }
  try {
    yield Api.post(`/map/buyBuilding`, {}, payload)
    yield put(
      pointsManagerActions.setPointsData({
        value: '-' + (buildingData.isFree ? 0 : buildingData.pricePerLevel[0]),
        icon: 'icon-coin',
        style: {},
      })
    )

    yield put(
      pointsManagerActions.setPointsData({
        value: '-' + (buildingData.isFree ? 0 : buildingData.pricePerLevel[0]),
        icon: 'icon-coin',
        style: {},
      })
    )
    yield put(audioActions.playHowlAudio('landing'))
  } catch (e) {
    console.log('Error buying building', e)
    if (e && e.status === 401) {
      console.log('Unauthorized')
      yield put(Game.actions.returnToPlatform())
    }
    yield put(audioActions.playHowlAudio('wrong_answer'))
  }
}

function* upgradeBuilding(action) {
  let building = action.data.building
  let tile = action.data.tile //q r
  let buildingData = (yield select(mapSelectors.getBuildings))[building.name]

  const userInfo = yield select(Auth.selectors.getUserInfo)
  const indicators = yield select(IndicatorsSelectors.getUserData)
  const maxIndex = buildingData.maxLevel - 1
  const displayingPrice = building.level < maxIndex ? building.level : maxIndex
  const payload = {
    groupId: userInfo.licenseData.groupId,
    playerId: userInfo.licenseId,
    turn: indicators.turn,
    building: {
      name: buildingData.id,
      type: buildingData.type,
      q: tile.q,
      r: tile.r,
      price: buildingData.pricePerLevel[displayingPrice],
    },
  }

  try {
    yield Api.post(`/map/evolveBuilding`, {}, payload)
    if (building.level < 3) {
      yield put(
        pointsManagerActions.setPointsData({
          value: '-' + buildingData.pricePerLevel[displayingPrice],
          icon: 'icon-coin',
          style: {},
        })
      )
    } else {
      yield put(
        pointsManagerActions.setPointsData({
          value: '-' + buildingData.pricePerLevel[displayingPrice],
          icon: 'icon-antimateria',
          style: { antimatter: true },
        })
      )
    }
    yield put(audioActions.playHowlAudio('upgrade'))
  } catch (e) {
    console.log('Error evolving building', e)
    if (e && e.status === 401) {
      console.log('Unauthorized')
      yield put(Game.actions.returnToPlatform())
    }
    yield put(audioActions.playHowlAudio('wrong_answer'))
  }
}

function* destroyBuilding(action) {
  let building = action.data.building
  let tile = action.data.tile //q r
  let buildingData = (yield select(mapSelectors.getBuildings))[building.name]
  let isDebris = buildingData.type == 'debris'
  let destroyingPrizes = [1, 5, 25, 250]
  let demolishDebrisPrize = 20

  const userInfo = yield select(Auth.selectors.getUserInfo)
  const indicators = yield select(IndicatorsSelectors.getUserData)
  const payload = {
    groupId: userInfo.licenseData.groupId,
    playerId: userInfo.licenseId,
    turn: indicators.turn,
    building: {
      name: buildingData.id,
      type: buildingData.type,
      q: tile.q,
      r: tile.r,
      price: isDebris ? demolishDebrisPrize : destroyingPrizes[building.level - 1],
      coins: isDebris ? 'antimatter' : 'gcoins',
    },
  }
  try {
    yield Api.post(`/map/destroyBuilding`, {}, payload)
    yield put(
      pointsManagerActions.setPointsData({
        value: '-' + (isDebris ? demolishDebrisPrize : destroyingPrizes[building.level - 1]),
        icon: isDebris ? 'icon-antimateria' : 'icon-coin',
        style: { antimatter: isDebris },
      })
    )
    yield put(audioActions.playHowlAudio('destruction'))
  } catch (e) {
    console.log('Error destroying building', e)
    yield put(audioActions.playHowlAudio('wrong_answer'))
    if (e && e.status === 401) {
      console.log('Unauthorized')
      yield put(Game.actions.returnToPlatform())
    }
  }
}

function* repareBuilding(action) {
  let building = action.data.building
  let tile = action.data.tile //q r
  let buildingData = (yield select(mapSelectors.getBuildings))[building.name]
  const indicators = yield select(IndicatorsSelectors.getUserData)
  const userInfo = yield select(Auth.selectors.getUserInfo)
  const payload = {
    groupId: userInfo.licenseData.groupId,
    playerId: userInfo.licenseId,
    turn: indicators.turn,
    building: {
      name: buildingData.id,
      type: buildingData.type,
      q: tile.q,
      r: tile.r,
      price: buildingData.pricePerLevel[building.level - 1],
    },
  }

  try {
    yield Api.post(`/map/repareBuilding`, {}, payload)
    yield put(
      pointsManagerActions.setPointsData({
        value: '-' + buildingData.pricePerLevel[building.level - 1],
        icon: 'icon-coin',
        style: {},
      })
    )
    yield put(audioActions.playHowlAudio('upgrade'))
  } catch (e) {
    console.log('Error reparing building', e)
    if (e && e.status === 401) {
      console.log('Unauthorized')
      yield put(Game.actions.returnToPlatform())
    }
  }
}

function* loadVisitorMap(action) {
  const uid = action.data
  const visitorIndicators = yield Firebase.sagas.loadUserData(uid)
  const visitorMap = yield Firebase.sagas.loadMap(uid, visitorIndicators.turn)

  yield put(mapActions.clearSprites())
  yield put(mapActions.setVisitorMap({ ...visitorMap, visitorId: uid }))
  yield put(indicatorsActions.setVisitorIndicators(visitorIndicators))
  yield put(activityActions.loadActivityDataVisitingPlayers(uid))
}

function* changeTurn() {
  const userInfo = yield select(Auth.selectors.getUserInfo)
  const indicators = yield select(IndicatorsSelectors.getUserData)

  let payload = {
    groupId: userInfo.licenseData.groupId,
    turn: indicators.turn,
  }

  yield put(surveyActions.loadSurvey())

  try {
    const ret = yield Api.put(`/nextTurn`, {}, payload)
    if (ret.newTurn) {
      yield put(phaseActions.nextTurn())
    }
  } catch (e) {
    console.log('Error changing turn', e)
    if (e && e.status === 401) {
      console.log('Unauthorized')
      yield put(Game.actions.returnToPlatform())
    }
  }
}

function* removeMountain() {
  const tile = yield select(mapSelectors.getSelectedTile)
  const userInfo = yield select(Auth.selectors.getUserInfo)
  const indicators = yield select(IndicatorsSelectors.getUserData)
  const payload = {
    groupId: userInfo.licenseData.groupId,
    playerId: userInfo.licenseId,
    turn: indicators.turn,
    removedRock: {
      q: tile.q,
      r: tile.r,
      price: 100,
      terrain: tile.terrain,
      height: tile.height,
    },
  }
  try {
    yield Api.post(`/map/demolishMountain`, {}, payload)
    yield put(
      pointsManagerActions.setPointsData({
        value: '-' + payload.removedRock.price,
        icon: 'icon-coin',
        style: {},
      })
    )
    yield put(audioActions.playHowlAudio('destruction'))
  } catch (e) {
    console.log('Error demolish mountain', e)
    yield put(audioActions.playHowlAudio('wrong_answer'))
    if (e && e.status === 401) {
      console.log('Unauthorized')
      yield put(Game.actions.returnToPlatform())
    }
  }
}

/**
 * Sagas entrypoint.
 */
export function* sagas() {
  yield init()

  yield takeEvery(mapActions.CREATE_BUILDING, createBuilding)
  yield takeEvery(mapActions.UPGRADE_BUILDING, upgradeBuilding)
  yield takeEvery(mapActions.DESTROY_BUILDING, destroyBuilding)
  yield takeEvery(mapActions.REPARE_BUILDING, repareBuilding)
  yield takeEvery(mapActions.LOAD_VISITOR_MAP, loadVisitorMap)
  yield takeEvery(mapActions.REMOVE_MOUNTAIN, removeMountain)
  yield takeEvery(mapActions.CHANGE_TURN, changeTurn)
}
